import DocumentChooserDialog from "./DocumentChooserDialog";

export default DocumentChooserDialog;